// Константы приложения

export const APP_CONFIG = {
  name: 'RCoffee',
  version: '1.0.0',
  description: 'Заказ кофе онлайн',
  supportEmail: 'support@quickly-coffee.com',
  supportPhone: '+7 (495) 123-45-67',
  offertaUrl: '/offerta' // Ссылка на публичную офферту
};

export const ROUTES = {
  HOME: '/',
  MENU: '/menu/:cafeId',
  CART: '/cart',
  ORDER: '/order/:orderId',
  PROFILE: '/profile'
};

export const ORDER_STATUS = {
  PENDING: 'pending',
  AWAITING_CONFIRMATION: 'awaiting_confirmation',
  CONFIRMED: 'confirmed',
  PAID: 'paid',
  PREPARING: 'preparing',
  READY: 'ready',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

export const ORDER_STATUS_LABELS = {
  [ORDER_STATUS.PENDING]: 'Ожидает подтверждения',
  [ORDER_STATUS.AWAITING_CONFIRMATION]: 'Требуется изменение',
  [ORDER_STATUS.CONFIRMED]: 'Подтверждён',
  [ORDER_STATUS.PAID]: 'Оплачен',
  [ORDER_STATUS.PREPARING]: 'Готовится',
  [ORDER_STATUS.READY]: 'Готов к выдаче',
  [ORDER_STATUS.COMPLETED]: 'Завершен',
  [ORDER_STATUS.CANCELLED]: 'Отменен'
};

export const MENU_CATEGORIES = {
  COFFEE: 'Кофе',
  CACAO: 'Какао',
  TEA: 'Чай',
  MATCHA: 'Матча',
  JUICE: 'Сок',
  LEMONADE: 'Лимонад',
  HOT_CHOCOLATE: 'Горячий шоколад',
  COLD_DRINKS: 'Холодные напитки',
  FOOD: 'еда',
  DESSERTS: 'десерты',
  SNACKS: 'снэки'
};

export const MENU_CATEGORY_LABELS = {
  [MENU_CATEGORIES.COFFEE]: 'Кофе',
  [MENU_CATEGORIES.CACAO]: 'Какао',
  [MENU_CATEGORIES.TEA]: 'Чай',
  [MENU_CATEGORIES.MATCHA]: 'Матча',
  [MENU_CATEGORIES.JUICE]: 'Сок',
  [MENU_CATEGORIES.LEMONADE]: 'Лимонад',
  [MENU_CATEGORIES.HOT_CHOCOLATE]: 'Горячий шоколад',
  [MENU_CATEGORIES.COLD_DRINKS]: 'Холодные напитки',
  [MENU_CATEGORIES.FOOD]: 'Еда',
  [MENU_CATEGORIES.DESSERTS]: 'Десерты',
  [MENU_CATEGORIES.SNACKS]: 'Снэки'
};

export const MENU_CATEGORY_ICONS = {
  [MENU_CATEGORIES.COFFEE]: '',
  [MENU_CATEGORIES.CACAO]: '',
  [MENU_CATEGORIES.TEA]: '',
  [MENU_CATEGORIES.MATCHA]: '',
  [MENU_CATEGORIES.JUICE]: '',
  [MENU_CATEGORIES.LEMONADE]: '',
  [MENU_CATEGORIES.HOT_CHOCOLATE]: '',
  [MENU_CATEGORIES.COLD_DRINKS]: '',
  [MENU_CATEGORIES.FOOD]: '',
  [MENU_CATEGORIES.DESSERTS]: '',
  [MENU_CATEGORIES.SNACKS]: ''
};

export const DRINK_SIZES = {
  S: { label: 'S', volume: '250 мл', priceMultiplier: 1 },
  M: { label: 'M', volume: '350 мл', priceMultiplier: 1.2 },
  L: { label: 'L', volume: '450 мл', priceMultiplier: 1.4 }
};

export const MILK_OPTIONS = {
  COW: { id: 'cow', label: 'Коровье молоко', price: 0 },
  OAT: { id: 'oat', label: 'Овсяное молоко', price: 30 },
  ALMOND: { id: 'almond', label: 'Миндальное молоко', price: 30 },
  SOY: { id: 'soy', label: 'Соевое молоко', price: 30 },
  COCONUT: { id: 'coconut', label: 'Кокосовое молоко', price: 30 }
};

export const SYRUP_OPTIONS = {
  VANILLA: { id: 'vanilla', label: 'Ванильный сироп', price: 25 },
  CARAMEL: { id: 'caramel', label: 'Карамельный сироп', price: 25 },
  CHOCOLATE: { id: 'chocolate', label: 'Шоколадный сироп', price: 25 },
  HAZELNUT: { id: 'hazelnut', label: 'Фундучный сироп', price: 25 },
  CINNAMON: { id: 'cinnamon', label: 'Коричный сироп', price: 25 }
};

export const PAYMENT_METHODS = {
  CARD: 'card',
  CASH: 'cash',
  TELEGRAM_PAY: 'telegram_pay'
};

export const PAYMENT_METHOD_LABELS = {
  [PAYMENT_METHODS.CARD]: 'Банковская карта',
  [PAYMENT_METHODS.CASH]: 'Наличные',
  [PAYMENT_METHODS.TELEGRAM_PAY]: 'Telegram Stars'
};

export const COLORS = {
  PRIMARY: '#5D4037',
  PRIMARY_HOVER: '#3E2723',
  SECONDARY: '#8D6E63',
  SUCCESS: '#2E7D32',
  WARNING: '#FF8F00',
  DANGER: '#C62828',
  INFO: '#6D4C41',
  LIGHT: '#F5F0EB',
  DARK: '#3E2723',
  WHITE: '#ffffff'
};

export const BREAKPOINTS = {
  MOBILE: '768px',
  TABLET: '1024px',
  DESKTOP: '1200px'
};

export const ANIMATION_DURATION = {
  FAST: '0.15s',
  NORMAL: '0.3s',
  SLOW: '0.5s'
};

export const MAP_CONFIG = {
  DEFAULT_CENTER: [55.7558, 37.6176], // Москва
  DEFAULT_ZOOM: 12,
  MIN_ZOOM: 10,
  MAX_ZOOM: 18
};

export const VALIDATION_RULES = {
  PHONE: /^\+?[1-9]\d{1,14}$/,
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  NAME: /^[а-яА-ЯёЁa-zA-Z\s]{2,50}$/
};

export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Ошибка сети. Проверьте подключение к интернету.',
  SERVER_ERROR: 'Ошибка сервера. Попробуйте позже.',
  VALIDATION_ERROR: 'Проверьте правильность введенных данных.',
  CART_EMPTY: 'Корзина пуста. Добавьте товары для оформления заказа.',
  CAFE_CLOSED: 'Кофейня сейчас закрыта.',
  ITEM_UNAVAILABLE: 'Товар временно недоступен.'
};

export const SUCCESS_MESSAGES = {
  ORDER_CREATED: 'Заказ успешно создан!',
  ITEM_ADDED: 'Товар добавлен в корзину',
  ITEM_REMOVED: 'Товар удален из корзины',
  CART_CLEARED: 'Корзина очищена'
};

export default {
  APP_CONFIG,
  ROUTES,
  ORDER_STATUS,
  ORDER_STATUS_LABELS,
  MENU_CATEGORIES,
  MENU_CATEGORY_LABELS,
  MENU_CATEGORY_ICONS,
  DRINK_SIZES,
  MILK_OPTIONS,
  SYRUP_OPTIONS,
  PAYMENT_METHODS,
  PAYMENT_METHOD_LABELS,
  COLORS,
  BREAKPOINTS,
  ANIMATION_DURATION,
  MAP_CONFIG,
  VALIDATION_RULES,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES
};
